import { useSplitTestBranch } from '../api/lendingApi/lendingApiQueries';
import { ISOLATED_SPLIT_TESTS } from '../constants';

export function useIsInDECompanySearchUITest() {
  const { splitTestBranch, isLoading } = useSplitTestBranch(
    ISOLATED_SPLIT_TESTS.DE_COMPANY_SEARCH_UI_TEST,
    { enabled: true, cookieOverride: true },
  );

  return {
    isLoading,
    splitTestBranch,
    isIncludedInCompanySearchUITest: splitTestBranch === 'INCLUDE',
  };
}
